import { cn } from '@/shell/lib/cn';

/**
 * Platzhalter in Blockgröße: feste Höhe, damit beim Eintreffen der Daten nichts springt (Kriterium D-12).
 * Bewusst ohne Ladeanimation (Gestaltungsgrundsatz 5).
 */
export function Skeleton({ height, className }: { height: number; className?: string }) {
  return (
    <div
      aria-hidden="true"
      style={{ height: `${height}px` }}
      className={cn('w-full rounded-surface bg-surface-sunken', className)}
    />
  );
}
